export enum MessageInnerType {
  Jobseeker = 1,
  Customer = 2,
  Subscriber = 3,
  CustomerAndJobseeker = 4,
}
